import { TicketOfficeView } from '../../../types/ticket-office';
import { DiscountsSectionProps } from '../../components/DiscountsSection';

export const getDiscountsSectionProps = (view: TicketOfficeView): DiscountsSectionProps => {
    const { state } = view;
    const { lang } = state;

    const discountsSection: DiscountsSectionProps = {
        label: lang.discounts.label,
        input: {
            serviceUrl: state.urls.addDiscountService,
            onSelect: view.stableCallbacks.onSelectDiscount,
            placeholder: lang.discounts.placeholder,
        },
    };

    return discountsSection;
};
